import { useFormikContext } from 'formik';
import { useState, useCallback } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import { NotifyPeopleTriggerButton } from 'hb-react/frontoffice/components/NotifyPeopleModal/NotifyPeopleTriggerButton';
import { type NotifyUser } from 'hb-react/frontoffice/components/NotifyPeopleModal/types';
import UserTargeting from 'hb-react/frontoffice/components/user_targeting';

import { type FormValues, type Job } from '../types';

export const Notify = ({ job }: { job?: Job }) => {
  const { setFieldValue, values } = useFormikContext<FormValues>();
  const [notifyPeople, setNotifyPeople] = useState<Array<NotifyUser>>([]);

  const authorized = job?.user_targeting?.authorized;
  const maxTargetedUsers = job?.user_targeting?.max_targeted_users;

  const handleValidateSelection = useCallback(
    (selectedUsers: Array<NotifyUser>, selectedUserIds: Array<number>) => {
      setNotifyPeople(selectedUsers);
      setFieldValue('targeted_user_ids', selectedUserIds);
    },
    [setFieldValue],
  );

  return authorized ? (
    <Box justifyContent="flex-end" ml={6} alignItems="center">
      <UserTargeting
        baseQuery={{ targeting_type: 'Posts::ForumPost' }}
        maxTargetedUsers={maxTargetedUsers}
        defaultSelectedUsers={notifyPeople}
        onValidateSelection={handleValidateSelection}
        renderTriggerElement={(onClick) => (
          <NotifyPeopleTriggerButton values={values} onClick={onClick} />
        )}
      />
    </Box>
  ) : null;
};
